import { ButtonContent, BookingStyledButton, BookingButtonContent } from './button-styles'
import { HoverText } from '../../seat-picker/seat-picker-styles'

type BookingTypeButtonProps = {
  disable?: boolean
  altText?: string
  buttonIcon?: JSX.Element
  buttonText: string
  onClick: () => void
  isPrimary?: boolean
  maxContent?: boolean
}

const BookingTypeButton = ({
  disable = false,
  maxContent = false,
  altText,
  buttonIcon,
  buttonText,
  isPrimary = true,
  onClick
}: BookingTypeButtonProps) => (
  <BookingStyledButton
    disabled={disable}
    onClick={onClick}
    isPrimary={isPrimary}
    title={`${altText || buttonText} button`}
    data-testid={`${buttonText.replace(' ', '-').toLowerCase()}-button`}
    maxContent={maxContent}
  >
    {disable ? <HoverText>{'Sorry, only one seat available'}</HoverText> : <></>}
    <BookingButtonContent>
      {buttonIcon && buttonIcon}
      <ButtonContent>{buttonText}</ButtonContent>
    </BookingButtonContent>
  </BookingStyledButton>
)

export default BookingTypeButton
